import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import INSIGHTS from '../data/insights';

function formatCategory(value) {
  return value
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function formatPublishedDate(value) {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export default function Insights() {
  return (
    <>
      <PageHero
        modifier="insights"
        kicker="Thought Leadership"
        title="Insights"
        desc="Architecture guidance, best practices and expert perspectives on SAP integration, analytics and ERP modernization."
      />
      <section className="section section-soft">
        <div className="container grid grid-3 animate-cards">
          {INSIGHTS.map((ins) => (
            <div className="card card--insight" key={ins.slug}>
              <span className="insight-tag">{formatCategory(ins.category || 'technology')}</span>
              <h3>{ins.title}</h3>
              <p>{ins.excerpt}</p>
              <div className="insight-footer">
                {ins.publishedDate ? <span className="read-badge">Published {formatPublishedDate(ins.publishedDate)}</span> : null}
                <Link className="link" to={`/insights/${ins.slug}`} style={{ fontSize: 13 }}>Read article &#8594;</Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
